import React from 'react'

export default function Dflex() {
  return (
    <div>
    <div className="container-fluid dflex1" id="skills" style={{
        maxWidth:'1440px', height:'auto', paddingTop:'60px',
        paddingBottom:'60px', textAlign:'center' 
    }}>
<div className="row dfex2" style={{
    maxWidth:'1280px',
}}>
<h1 className='little-malio-font  dflemainh1 pb-5' style={{ fontWeight:'400'}}>MY SKILLS</h1>
{/* <div className="row" style={{

  paddingTop: '20px',
}}> */}
      <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2 mt-3" style={{
    border: '2px solid black',
    alignItems: 'center',
     borderRadius:'4px', backgroundColor:'black'
  }}>
    <img src="/images/dfour.png" alt="" srcset="" className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4 dflexh1 text-white little-malio-font' style={{fontWeight:'400'}}>PHOTOSHOP</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2 mt-3" style={{
   border: '2px solid black',
   alignItems: 'center',
 borderRadius:'4px',
  }}>
    <img src="/images/Group.png" alt="" srcset="" className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4  dflexh1 little-malio-font' style={{ fontWeight:'400'}}>ILLUSTRATOR</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2 mt-3" style={{
   border: '2px solid black',
   alignItems: 'center', borderRadius:'4px', 
  }}>
    <img src="/images/dsix.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }}  />
    <h1 className='pt-4  dflexh2 little-malio-font' style={{fontWeight:'400'}}>AFTER EFFECTS</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2  mt-3" style={{
   border: '2px solid black',
   alignItems: 'center',borderRadius:'4px',
  }}>
    <img src="/images/dfive.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }}  />
    <h1 className='pt-4 dflexh2 little-malio-font' style={{fontWeight:'400'}}>PREMIERE PRO</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2 mt-3" style={{
     border: '2px solid black',
     alignItems: 'center', borderRadius:'4px', 
  }}>
    <img src="/images/deith.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4 dflexh1 little-malio-font' style={{fontWeight:'400'}}>AUDITION</h1>
  </div>
{/* </div> */}


{/* <div className="row" style={{
  paddingBottom: '20px',
  textAlign: 'center',
}}> */}
      <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2 mt-3" style={{
   border: '2px solid black',
   alignItems: 'center', borderRadius:'4px',
  }}>
    <img src="/images/dseven.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4 dflexh3 little-malio-font' style={{fontWeight:'500'}}>DAVINCI RESOLVE</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2 mt-3" style={{
    border: '2px solid black',
    alignItems: 'center', borderRadius:'4px', 
  }}>
    <img src="/images/done.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4 dflexh1 little-malio-font' style={{fontWeight:'400'}}>MID JOURNEY</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mx-2 mt-3" style={{
   border: '2px solid black',
   alignItems: 'center', borderRadius:'4px',
  }}>
    <img src="/images/dthree.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4 dflexh1 little-malio-font' style={{fontWeight:'400'}}>FIGMA</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mt-3 mx-2" style={{
   border: '2px solid black',
   alignItems: 'center', borderRadius:'4px',
  }}>
    <img src="/images/dnine.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4 dflexh1 little-malio-font' style={{fontWeight:'400'}}>MAYA</h1>
  </div>
  <div className="col-lg-2 col-md-4 col-sm-6 col-sml-6 dflex3 mt-3 mx-2" style={{
     border: '2px solid black',
     alignItems: 'center', borderRadius:'4px',
  }}>
    <img src="/images/d1.png" alt="" srcset=""  className='mt-3' style={{
      width:'45px', height:'46px'
    }} />
    <h1 className='pt-4 dflexh1 little-malio-font' style={{fontWeight:'400'}}>CINEMA 40</h1>
  </div>
{/* </div> */}
</div>
    </div>
    </div>
  )
}
